import React, { useState } from 'react';
import { CollapseArrow } from 'structure/Layer.js';

const CollapseContainer = ({ arrowStyle, children, defaultValue, header, onChange, style }) => {

    const [collapsed, setCollapsed] = useState(defaultValue || false);

    const onCollapseChange = val => {
        setCollapsed(val);
        if(typeof(onChange) === 'function') {
            onChange(val);
        }
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            ...style
        }}>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                minWidth: 0,
                width: '100%'
            }}>
                <div 
                className={'text-button'}
                onClick={onCollapseChange.bind(this, !collapsed)}
                style={{
                    flexGrow: 1
                }}>
                    {header}
                </div>
                <CollapseArrow 
                collapsed={collapsed}
                onClick={onCollapseChange} 
                style={{
                    marginRight: 24,
                    ...arrowStyle
                }}
                value={collapsed} />
            </div>
            {collapsed === false && children}
        </div>
    )
}

export default CollapseContainer;